<template>
  <div>
    <BasePage v-bind="config" :list="filterList" v-on="listeners"></BasePage>
  </div>
</template>

<script>
import BasePage from './BasePage.vue'
import {sspApi} from '@/api';
import _ from 'lodash';
import exportUtils from '@/components/util/export-utils.js';
import {ADSlotTypeEnum, StatusEnum, PricingStrategyEnum} from '@/enums/enums';

export default {
  components: {
    BasePage
  },
  data: function () {
    return {
      queryCondition: {
        id: '',
        name: '',
        adResourceType: '',
        pricingStrategy: '',
        modifier: '',
        status: '',
        mediaId: ''
      },
      list: [],
      listeners: {
        input: this.onInput,
        operation: this.doOperation,
        action: this.doAction,
      },
      config: {
        searchConfigs: [
          [
            {name: 'id', label: '广告位ID(Ad Slot ID)', ctx: 'inputText'},
            {name: 'name', label: '广告位名称(Ad Slot Name)', ctx: 'inputText'},
            {
              name: 'adResourceType', label: '广告位资源类型(Ad Slot Type)', ctx: 'inputSelect',
              options: Object.values(ADSlotTypeEnum)
            },
            {
              name: 'pricingStrategy', label: '价格策略(Pricing Strategy)', ctx: 'inputSelect',
              options: Object.values(PricingStrategyEnum)
            },
            {name: 'modifier', label: '修改人(Modifier)', ctx: 'inputText'},
            {
              name: 'status', label: '状态(Status)', ctx: 'inputSelect',
              options: Object.values(StatusEnum)
            },
            {name: 'mediaId', label: '所属媒体ID (Belonged Media ID)', ctx: 'inputText'}
          ]
        ],
        tableConfigs: [
          {prop: 'id', label: '广告位ID(Ad Slot ID)'},
          {prop: 'name', label: '广告位名称(Ad Slot Name)'},
          {prop: 'adResourceTypeName', label: '广告位资源类型(Ad Slot Type)'},
          {prop: 'pricingStrategy', label: '价格策略(Pricing Strategy)', headerTooltip: 'Unit: USD/Mille'},
          {prop: 'mediaId', label: '所属媒体ID (Belonged Media ID)'},
          {prop: 'updateTime', label: '修改时间(Modification Time)', width: '200'},
          {prop: 'modifier', label: '修改人(Modifier)'},
          {prop: 'statusName', label: '状态(Status)', width: '100'},
          {prop: 'operation', label: '操作(Operate)', width: '105'}
        ]
      }
    }
  },
  created: function () {
    sspApi.listAdzone().then((response) => {
      this.list = response.map(it => {
        const adResourceType = Object.values(ADSlotTypeEnum).find(p => p.id === it.adResourceType);
        const status = Object.values(StatusEnum).find(s => s.id === it.status);
        const pricingStrategy = it.reservePrice !== null ? `${PricingStrategyEnum.STATIC.name}: $${it.reservePrice}`: PricingStrategyEnum.DYNAMIC.name
        return {
          ...it,
          pricingStrategy: pricingStrategy,
          adResourceTypeName: adResourceType ? adResourceType.name : '',
          statusName: status ? status.name : ''
        }
      });
    }).catch(this.$rejectAjaxError());
  },
  computed: {
    filterList: function () {
      let {id, name, adResourceType, pricingStrategy, modifier, status, mediaId} = this.queryCondition
      return _.filter(this.list, (it) => {
        return (id === '' || String(it.id).includes(id)) &&
            (name === '' || String(it.name).includes(name)) &&
            (adResourceType === '' || it.adResourceType === adResourceType) &&
            (pricingStrategy === '' || (pricingStrategy === 1 ? it.reservePrice === null : it.reservePrice !== null)) &&
            (modifier === '' || String(it.modifier).includes(modifier)) &&
            (status === '' || it.status === status) &&
            (mediaId === '' || String(it.mediaId).includes(mediaId))
      })
    }
  },
  methods: {
    onInput: function (val) {
      _.assign(this.queryCondition, val);
    },
    doOperation: function (op) {
      let adzoneId = op.item.id
      if (op.name === 'edit') {
        this.$router.push({name: 'adzoneEdit', params: {adzoneId}})
      }
    },
    doAction: function (name) {
      if (name === 'create') {
        this.$router.push({name: 'adzoneNew'})
      }
      if (name === 'export') {
        exportUtils.export(this.filterList, this.config.tableConfigs)
      }
    }
  }
}
</script>